import React from "react";
import styled, { keyframes, css, useTheme } from "styled-components";
import {
  GridCol,
  GridRow,
  Header,
  Subheader,
  ButtonText,
  Button,
  Link,
} from "../components";
import { layout, space, flexbox, position, color } from "styled-system";
import Logo from "../assets/logo.png";
import Dribbble from "../assets/dribbble.png";
import Instagram from "../assets/instagram.png";
import Etsy from "../assets/etsy.png";
import Youtube from "../assets/youtube.png";

import Image1 from "../assets/1.gif";
import Image2 from "../assets/2.gif";
import Image3 from "../assets/3.gif";
import MySweetChubs from "../assets/mysweetchubs_pink.png";

const Image = styled.img`
  ${layout};
  ${space};
  ${position};
`;

const Container = styled.div`
  display: inline-flex;
  transition: opacity 0.25s cubic-bezier(0.165, 0.84, 0.44, 1);

  ${space};
  ${layout};
  ${flexbox};
  ${color};
`;

const grow = keyframes`
    0% { transform: scale(0.25); visibility: visible;}
    25% { transform: scale(0.5); visibility: visible;}
    75% { transform: scale(0.25); visibility: visible;}
    100% { transform: scale(1); visibility: visible;}
`;

const Shape = styled.svg`
  ${position};
  animation: ${({ animation, animationLength }) =>
    animation &&
    animationLength &&
    css`
      ${animation} ${animationLength} ${({ theme }) => theme.cubicBezier}
    `};
  animation-delay: ${({ animationDelay }) =>
    animationDelay &&
    css`
      ${animationDelay}
    `};
  transform-origin: ${({ transformOrigin }) => transformOrigin};
  fill: ${({ color }) => color};
  visibility: ${({ animation }) => animation && "hidden"};
  animation-fill-mode: forwards;
`;

const Tablet = ({ copy }) => {
  const { colors } = useTheme();

  return (
    <>
      <GridRow pt={50}>
        <GridCol tablet={12} textAlign="center" justifyItems="center">
          <Header color={"lightGreen"} textAlign="center">
            WELCOME TO
          </Header>
          <Image width={"50%"} src={MySweetChubs} />
          <Link href="/">
            <Image pb={10} width="45%" src={Logo} />
          </Link>
          <Container
            justifyContent="center"
            style={{ display: "grid", gridAutoFlow: "column" }}
          >
            <Link href="https://bit.ly/mysweetchubs-dribbble-website">
              <Image height={60} src={Dribbble} pl={10} pr={10} />
            </Link>
            <Link href="https://bit.ly/mysweetchubs-instagram">
              <Image height={60} src={Instagram} pl={10} pr={10} />
            </Link>
            <Link href="https://bit.ly/mysweetchub-shop">
              <Image height={60} src={Etsy} pl={10} pr={10} />
            </Link>
            <Link href="https://bit.ly/designcodeepisode2">
              <Image height={60} src={Youtube} pl={10} pr={10} />
            </Link>
          </Container>
        </GridCol>
      </GridRow>
      <GridRow pt={100} pb={150}>
        <GridCol tablet={1} />
        <GridCol tablet={5}>
          <Container flexDirection="column">
            <Header pb={10} color={colors.green}>
              {copy.section1.header}
            </Header>
            <Subheader color={colors.green}>
              {copy.section1.subheader}
            </Subheader>
            <Link href="https://bit.ly/mysweetchubs-instagram">
              <Button backgroundColor={colors.lightGreen} mt={30}>
                <ButtonText color={colors.white}>click me!</ButtonText>
              </Button>
            </Link>
          </Container>
        </GridCol>
        <GridCol tablet={5} position="relative">
          <Shape
            position="absolute"
            fill={colors.lightGreen}
            top={0}
            left={0}
            height="100%"
            width="100%"
            viewBox="0 0 100 100"
            animation={grow}
            animationDelay={"1.25s"}
            animationLength={"2s"}
          >
            <circle r="50" cx="50" cy="50" />
          </Shape>
          <Image position="absolute" src={Image1} bottom={0} width="100%" />
        </GridCol>
        <GridCol tablet={1} />
      </GridRow>
      <GridRow pb={150}>
        <GridCol tablet={1} />
        <GridCol tablet={5} position="relative">
          <Shape
            position="absolute"
            fill={colors.lightBlue}
            top={0}
            left={0}
            viewBox="0 0 100 100"
            height="100%"
            width="100%"
            animation={grow}
            animationDelay={"1.25s"}
            animationLength={"2s"}
          >
            <circle r="50" cx="50" cy="50" />
          </Shape>
          <Image position="absolute" src={Image2} bottom={0} width="100%" />
        </GridCol>
        <GridCol tablet={5}>
          <Container flexDirection="column">
            <Header pb={10} color={colors.blue}>
              {copy.section2.header}
            </Header>
            <Subheader color={colors.blue}>{copy.section2.subheader}</Subheader>
            <Link href="https://bit.ly/mysweetchub-shop">
              <Button backgroundColor={colors.lightBlue} mt={30}>
                <ButtonText color={colors.white}>click me!</ButtonText>
              </Button>
            </Link>
          </Container>
        </GridCol>
        <GridCol tablet={1} />
      </GridRow>
      <GridRow pb={150}>
        <GridCol tablet={1} />
        <GridCol tablet={5}>
          <Container flexDirection="column">
            <Header pb={10} color={colors.coral}>
              {copy.section3.header}
            </Header>
            <Subheader color={colors.coral}>
              {copy.section3.subheader}
            </Subheader>
            <Link href="https://bit.ly/mysweetchubs-dribbble-website">
              <Button backgroundColor={colors.lightCoral} mt={30}>
                <ButtonText color={colors.white}>click me!</ButtonText>
              </Button>
            </Link>
          </Container>
        </GridCol>
        <GridCol tablet={5} position="relative">
          <Shape
            position="absolute"
            fill={colors.lightCoral}
            top={0}
            left={0}
            viewBox="0 0 100 100"
            height="100%"
            width="100%"
            animation={grow}
            animationDelay={"1.25s"}
            animationLength={"2s"}
          >
            <circle r="50" cx="50" cy="50" />
          </Shape>
          <Image position="absolute" src={Image3} bottom={0} width="100%" />
        </GridCol>
        <GridCol tablet={1} />
      </GridRow>
      <Container
        pb={100}
        mr={0}
        ml={0}
        width="100%"
        display="flex"
        flexDirection="column"
        alignItems="center"
        style={{
          background: "linear-gradient(180deg, #FFFFFF 0%, #FFF3CB 100%)",
        }}
      >
        <Header color="brown">come again!</Header>
        <Image pb={10} width="30%" src={Logo} />
      </Container>
    </>
  );
};

export default Tablet;
